<template>
  <div class="create-user-container">
    <h2 class="text-center mb-5 title-user">Criar Usuário</h2>
    <b-form @submit.prevent="createUser">
      <b-form-group class="tittle-lable" label="Nome:" label-for="nome">
        <b-form-input
          id="nome"
          v-model="form.nome"
          type="text"
          placeholder="Digite o nome"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group class="tittle-lable" label="Email:" label-for="email">
        <b-form-input
          id="email"
          v-model="form.email"
          type="email"
          placeholder="Digite o email"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group class="tittle-lable" label="Senha:" label-for="senha">
        <b-form-input
          id="senha"
          v-model="form.senha"
          type="password"
          placeholder="Digite a senha"
          required
        ></b-form-input>
      </b-form-group>

      <b-button type="submit" class="btn-cadastrar">Cadastrar</b-button>
    </b-form>

    <b-alert v-if="successMessage" variant="success" dismissible>
      {{ successMessage }}
    </b-alert>
    <b-alert v-if="errorMessage" variant="danger" dismissible>
      {{ errorMessage }}
    </b-alert>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CreateUserView",
  data() {
    return {
      form: {
        nome: "",
        email: "",
        senha: "",
      },
      successMessage: "",
      errorMessage: "",
    };
  },
  methods: {
    async createUser() {
      try {
        const response = await axios.post("https://api-autoatendimento.nextcomm.tech/api/v1/users/", this.form);
        //const response = await axios.post("http://127.0.0.1:19000/api/v1/users/", this.form);
        this.successMessage = "Usuário criado com sucesso!";
        this.errorMessage = "";

        // Limpar o formulário após o sucesso
        this.form.nome = "";
        this.form.email = "";
        this.form.senha = "";
      } catch (error) {
        this.successMessage = "";
        this.errorMessage = error.response?.data?.detail || "Erro ao criar usuário.";
      }
    },
  },
};
</script>

<style scoped>
  .create-user-container {
    max-width: 400px;
    margin: 0 auto;
    padding: 20px;
  }

  h2 {
    text-align: center;
    color: #008a36;
    margin-bottom: 20px;
  }

  b-button {
    width: 100%;
  }

  /* Adiciona sombra verde a todos os campos de entrada ao focar */
  .b-form-input[type="text"]:focus,
  .b-form-input[type="email"]:focus,
  .b-form-input[type="password"]:focus,
  input[type="text"]:focus,
  input[type="email"]:focus,
  input[type="password"]:focus {
    box-shadow: 0 0 5px 2px #00b044; /* Sombra verde */
    border-color: #00b044; /* Borda verde */
    color: #27471e;
  }

/* Estilo específico para labels dentro do b-form-group */
  .tittle-lable {
    color: #27471e !important; /* Cor verde escuro */
    font-weight: bold !important; /* Negrito */
  }

  .btn-cadastrar {
    background-color: #27471e; /* Cor do botão */
    color: white; /* Cor do texto */
    border: none;
  }

  .btn-cadastrar:hover {
    background-color: #00b044; /* Cor mais escura no hover */
  }

  .title-user {
    font-weight: bold;
    color: #27471e;
  }
</style>